import React, { Component } from 'react'
import { Field, reduxForm, change } from 'redux-form'
import { connect } from 'react-redux'
import { withStyles } from '@material-ui/core/styles'
import cx from 'classnames'
import Spinner from '../spinner'
import { ButtonContained } from '../app-button/button'
import { required } from './validation/validation'
import renderSelectField from './field/customSelect'
import MenuItem from '@material-ui/core/MenuItem'

const styles = theme => ({
  form: {
    width: '100%',
  },
  invalid: {},
  '@keyframes wiggle': {
    '33%': { transform: 'rotateZ(1deg)' },
    to: { transform: 'rotateZ(-1deg)' },
  },
  inputWrapper: {
    marginBottom: '20px',
  },
  wiggle: {
    willChange: 'transform',
    animationName: 'wiggle',
    animationDuration: '150ms',
    animationIterationCount: 4,
  },
})

class ReportSettingsFormV1 extends Component {
  render() {
    const {
      classes,
      handleSubmit,
      isFetching,
      submitFailed,
      invalid,
      goals,
    } = this.props

    const goalsList = () => {
      return goals.map(goal => {
        return (
          <MenuItem value={goal.id} key={goal.id}>
            {goal.name} (ID: {goal.id})
          </MenuItem>
        )
      })
    }

    return (
      <form
        onSubmit={handleSubmit}
        className={cx(
          classes.form,
          { [classes.wiggle]: submitFailed },
          { [classes.novalidate]: invalid }
        )}
        ref={form => (this.form = form)}
      >
        <div
          style={{
            fontSize: '14px',
            marginBottom: '16px',
          }}
        >
          Для настройки дашборда мы рекомендуем:
          <ol style={{ padding: '0 0 0 15px' }}>
            <li>
              Настроить цель на заявку с сайта в вашем Google Analytics и
              указать ее, как «Заявка» в дашборде ROMI center;
            </li>
            <li>
              Подключить CRM систему и указать либо цель «Успешные продажи»,
              либо событие электронной торговли «Транзакции» в качестве
              «Продажи» в дашборде ROMI center.
            </li>
          </ol>
        </div>
        <div
          style={{
            fontSize: '14px',
            marginBottom: '16px',
          }}
        >
          Укажите, какие цели из Google Analytics считать “Заявкой”:
        </div>
        <div className={classes.inputWrapper}>
          <Field
            name="leads"
            component={renderSelectField}
            validate={[required]}
          >
            <MenuItem value="" style={{ display: 'none' }}>
              <span style={{ color: 'rgb(0, 0, 0, 0.3)' }}>Заявка это ...</span>
            </MenuItem>
            {goalsList()}
          </Field>
        </div>

        <div
          style={{
            fontSize: '14px',
            marginBottom: '16px',
          }}
        >
          Укажите, какие цели из Google Analytics считать “Продажей”:
        </div>
        <div className={classes.inputWrapper}>
          <Field
            name="orders"
            component={renderSelectField}
            validate={[required]}
          >
            <MenuItem value="" style={{ display: 'none' }}>
              <span style={{ color: 'rgb(0, 0, 0, 0.3)' }}>
                Продажа это ...
              </span>
            </MenuItem>
            {goalsList()}
          </Field>
        </div>

        <ButtonContained
          style={{
            height: 46,
            fontSize: 16,
            width: '100%',
            padding: 0,
            fontWeight: 600,
          }}
          type="submit"
          color="secondary"
          text={isFetching ? <Spinner stroke="#000000" /> : 'Сохранить'}
        />
      </form>
    )
  }
}

const mapDispatchToProps = {
  change,
}

ReportSettingsFormV1 = reduxForm({
  form: 'ReportSettingsFormV1',
  enableReinitialize: true,
})(connect(null, mapDispatchToProps)(ReportSettingsFormV1))

export default withStyles(styles)(ReportSettingsFormV1)
